/*
*@Author: dcl
*@Description: 许可证页面
*@Date: 2022-11-14 11:33:35
*/
<template>
  <div class="ili">
    <el-image :src="info_3" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      info_3: require("../../assets/info_3.jpg")
    };
  }
};
</script>

<style scoped lang="less">
.ibi {
  width: 100%;
  img {
    width: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/view/Information/license.vue